import { FeatureToggle } from '@/util/config';

const merge = (parsed: Record<string, unknown>) => {
  const merged: Partial<FeatureToggle> = {};

  const final = () => merged;

  const add = (
    propName: keyof FeatureToggle,
    condition: (propValue: unknown) => boolean,
  ) => {
    if (condition(parsed[propName])) {
      // @ts-ignore
      merged[propName] = parsed[propName];
    }
    return {
      add,
      final,
    };
  };

  return {
    add,
  };
};

const parse = (rawData: Record<string, unknown>): Partial<FeatureToggle> => {
  const validated = merge(rawData)
    .add('enableKeycloak', (val) => typeof val === 'boolean')
    .add('showLanguageMenu', (val) => typeof val === 'boolean')
    .add('loginScreenEnabled', (val) => typeof val === 'boolean')
    .add('donwloadCenterEnabledPaths', (val) => Array.isArray(val))
    .add('chatEnabledRoles', (val) => Array.isArray(val))
    .add('keycloakEnabledPathsCdd', (val) => Array.isArray(val))
    .add('keycloakEnabledPathsRevenda', (val) => Array.isArray(val))
    .final();

  return validated;
};

const loadFeatureToggle = async (pathPrefix: string) => {
  const filePath = `${pathPrefix}/feature-toggle.json`.replace('//', '/');
  const fileUrl = `${location.origin}${filePath}`;

  try {
    const response = await fetch(fileUrl, {
      signal: AbortSignal.timeout(20000),
    });

    const parsed = parse(await response.json());
    return parsed;
  } catch {
    return null;
  }
};

export { parse };

export default loadFeatureToggle;
